import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { untilDestroy } from '../../../shared/operators/untilDestroy';
import { CompleteResultNotification } from '../../models';
import { ReportService } from '../../services/report.service';
import { EReportViewModel, ViewModeService } from '../../services/view-mode.service';
import { ALERTS } from '../../utils/constants';
import { PanelComponent, PanelHeaderComponent, PanelActionsComponent, PanelActionComponent, PanelBodyComponent } from '../../../panel/panel.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgFor, NgClass } from '@angular/common';
import { AlertCardComponent } from '../alert-card/alert-card.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { PoweredByComponent } from '../powered-by/powered-by.component';

@Component({
    selector: 'cr-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    imports: [PanelComponent, PanelHeaderComponent, PanelActionsComponent, PanelActionComponent, MatButton, MatTooltip, MatIcon, PanelBodyComponent, FlexModule, NgFor, AlertCardComponent, NgClass, ExtendedModule, PoweredByComponent]
})
export class AlertsComponent implements OnInit, OnDestroy {
	notification: CompleteResultNotification;
	get selectedAlert() {
		return this.viewModeService?.selectedAlert;
	}
	constructor(private reportService: ReportService, private viewModeService: ViewModeService) {}
	/**
	 * Life-cycle method
	 */
	ngOnInit() {
		this.reportService.completeResult$
			.pipe(
				untilDestroy(this),
				filter(c => !!c.notifications && !!c.notifications.alerts && !!c.notifications.alerts.length)
			)
			.subscribe(completeResult => {
				this.notification = JSON.parse(JSON.stringify(completeResult.notifications));
				if (this.notification) {
					this.notification.alerts = this.notification.alerts.filter(n => n.code != ALERTS.SUSPECTED_AI_TEXT_DETECTED);
				}
			});
	}
	/**
	 * hide alerts and go back to scanning mode
	 */
	hideAlerts() {
		this.viewModeService.changeViewMode$(EReportViewModel.ScanningResult);
	}
	/**
	 * Life-cycle method
	 * required by untilDestory
	 */
	ngOnDestroy() {}
}
